module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Hf46"))).then(() => parcelRequire('d0iPb'));